import { reskinStyles } from 'core/components/theme/theme-variant';

// New-look menus use neutral hover and a bold selected option.
const overrideListItems = (theme) => {
  const hovered = { backgroundColor: theme.colorPalette.beige_50, color: theme.colors.text_primary };
  theme.overrides.MuiListItem = {
    root: {
      // Reskin: keyboard focus gets the hover highlight, since the global focus outline is off for options.
      ...reskinStyles(theme, { '&$focusVisible': { backgroundColor: theme.colorPalette.beige_50 } }),
      '&$selected': {
        backgroundColor: theme.colorPalette.white,
        fontWeight: 600,
        ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, fontWeight: 700 }),
        '&:hover': {
          backgroundColor: theme.colorPalette.green_75_op_10,
          ...reskinStyles(theme, hovered)
        }
      }
    },
    button: {
      '&:hover': {
        color: theme.palette.common.green_100,
        backgroundColor: theme.colorPalette.green_75_op_10,
        ...reskinStyles(theme, hovered)
      }
    }
  };
};

export default overrideListItems;
